import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { EditIcon, DeleteIcon } from './icons';

interface RowActionsProps {
  onEdit: () => void;
  onDelete: () => void;
}

const RowActions: React.FC<RowActionsProps> = ({ onEdit, onDelete }) => (
  <View style={styles.rowActions}>
    <TouchableOpacity style={styles.iconBtn} onPress={onEdit} activeOpacity={0.7}>
      <EditIcon />
    </TouchableOpacity>
    <TouchableOpacity style={styles.iconBtn} onPress={onDelete} activeOpacity={0.7}>
      <DeleteIcon />
    </TouchableOpacity>
  </View>
);

const styles = StyleSheet.create({
  rowActions: {
    flexDirection: 'row',
    gap: 4,
  },
  iconBtn: {
    width: 28,
    height: 28,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
  },
});

export default RowActions;
